import { render, staticRenderFns } from "./Articulos.vue?vue&type=template&id=2e9ee1fc&scoped=true"
import script from "./Articulos.vue?vue&type=script&lang=js"
export * from "./Articulos.vue?vue&type=script&lang=js"
import style0 from "./Articulos.vue?vue&type=style&index=0&id=2e9ee1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ee1fc",
  null
  
)

export default component.exports